module.exports = __webpack_public_path__ + "static/media/support.28b59fd4.webp";